import { CRAWL_REDIRECT } from '@components/App/SystemDialogs/constants'
import { openSystemDialog } from '@storeOld/reducers/ui'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import type { CrawlerRedirect } from '@/types'
import { crawlRedirectCardClass } from './CrawlRedirectDialog'

export const useCrawlRedirect = (
  redirect: CrawlerRedirect | null,
  onConfirm: (url: string) => void,
  onCancel: () => void
) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!redirect) {
      return
    }

    let answered = false

    dispatch(
      openSystemDialog(CRAWL_REDIRECT, {
        ...redirect,
        cardClassName: crawlRedirectCardClass,
        isLocked: true,
        callback: (confirmed: boolean) => {
          if (answered) {
            return
          }
          answered = true
          if (confirmed) {
            onConfirm(redirect.destinationUrl)
          } else {
            onCancel()
          }
        },
      })
    )
  }, [redirect])
}
